import { render, staticRenderFns } from "./WarehousesEdit.vue?vue&type=template&id=bbe4e6ee&"
import script from "./WarehousesEdit.vue?vue&type=script&lang=js&"
export * from "./WarehousesEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports